import { Messages } from "app/types/common"
import { Config, Locale, Item } from "./types"

export const iscPresets = (item: Item, isRTL: boolean, messages: Messages, locale: Locale ,config: Config, loyaltySegment: string, reservationCount: number) => {
    return {
    ...item,
    isRTL,
    messages,
    locale: {
        ...locale,
        locale: locale.langISO,
    },
    brand: {
        brandId: config.head.business,
    },
    config: {
        imageSphere: { quality: 85 },
        wcs: {
            external: config.global.services.commerce,
            productsByCategoryPath:
                'search/resources/store/{{brandSite}}/productview/byCategory?category={{seoUrl}}&pageSize={{pageSize}}&pageNumber={{pageNumber}}&locale={{locale}}',
        },
    },
    urlConfig: config.global.urlConfig,
    item: {
        ...item,
        messages,
    },
    tier: loyaltySegment,
    reservationCount,
}
}